var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.status === false)?_c('div',{staticClass:"text-center my-5 py-5 font-2xl"},[_c('strong',[_vm._v("There is currently no data for this section")])]):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }